import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@gemini/core';
import { ChevronDownIcon, ChevronUpIcon } from '@gemini/icons';
import { OfferCardTransactionTypePrice } from './OfferCardTransactionTypePrice';
export function OfferCardPriceAccordionMobile({ isContentOpen, setIsContentOpen, }) {
    const handleAccordionClick = (event) => {
        event.preventDefault();
        setIsContentOpen(!isContentOpen);
    };
    return (_jsx(Box, { testId: "offer-card-price-accordion-mobile", cursor: "pointer", as: "button", onClick: handleAccordionClick, borderStyle: "none", width: "100%", padding: "spacing.none", children: _jsx(Box, { padding: "spacing.16", children: _jsx(OfferCardTransactionTypePrice, { withDiscountTag: true, finalPriceIcon: isContentOpen ? _jsx(ChevronUpIcon, {}) : _jsx(ChevronDownIcon, {}), onFinalPriceIconClick: handleAccordionClick }) }) }));
}
